import { render, staticRenderFns } from "./index.vue?vue&type=template&id=80b68dbe&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=80b68dbe&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b68dbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80b68dbe')) {
      api.createRecord('80b68dbe', component.options)
    } else {
      api.reload('80b68dbe', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=80b68dbe&scoped=true", function () {
      api.rerender('80b68dbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TipOnclick/index.vue"
export default component.exports